(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-base"] && !Shopify.designMode) return;
  try {
    (function(){
  // Load brand fonts once (Sansita display + Open Sans body)
  if (!document.getElementById('mc-fonts')) {
    var pre1 = document.createElement('link'); pre1.rel = 'preconnect'; pre1.href = 'https://fonts.googleapis.com';
    var pre2 = document.createElement('link'); pre2.rel = 'preconnect'; pre2.href = 'https://fonts.gstatic.com'; pre2.crossOrigin = 'anonymous';
    var l = document.createElement('link');
    l.id = 'mc-fonts'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Sansita:ital,wght@0,400;0,700;0,800;1,700&family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,400&display=swap';
    document.head.appendChild(pre1); document.head.appendChild(pre2); document.head.appendChild(l);
  }
})();
(function(){
  if (window.MCCustomise) return;
  // All three come from the product's own options. /mix/i would also match
  // "Mixture"; TEXTURE_RX is checked FIRST because "Grinding Texture" would
  // otherwise be caught by a looser pattern.
  var TEXTURE_RX = /texture/i, MIXTURE_RX = /mix/i, WEIGHT_RX = /weight|size/i;

  // The full catalogue range, in display order: plain flour before the paid
  // add-ins, finest mill before coarsest. Every one of these is rendered on
  // every product that has the option, so a mix missing in one city still
  // appears — disabled — rather than vanishing.
  var MIX_ORDER = ['No Mix', 'Protein', 'Millet', 'Multigrain'];
  var TEX_ORDER = ['Baareek', 'Medium', 'Mota'];

  // The master list, plus anything ITC adds later that is not on it yet. A
  // strict allowlist would silently drop a new mix from the popup while it
  // still existed as a buyable variant.
  function universe(preferred, productValues) {
    var extra = (productValues || []).filter(function (v) { return preferred.indexOf(v) === -1; });
    return preferred.concat(extra);
  }

  var state = null, el = null;
  function fmt(paise){
    var v = paise / 100;
    return '\u20B9' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function build(){
    el = document.createElement('div');
    el.className = 'mc-cz';
    el.innerHTML = '<div class="mc-cz__ovl" data-cz-close></div>'+
      '<div class="mc-cz__box" role="dialog" aria-modal="true" aria-label="Customisation">'+
      '<div class="mc-cz__head"><span class="mc-cz__title">Customisation</span>'+
      '<button class="mc-cz__x" type="button" data-cz-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'+
      '<div class="mc-cz__banner" data-cz-banner><em data-cz-banner-name></em><span data-cz-banner-charge></span></div>'+
      '<div class="mc-cz__note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1"/></svg><span data-cz-note></span></div>'+
      '<div data-cz-mix-wrap><div class="mc-cz__lbl">Grinding Mixture</div><div class="mc-cz__chips" data-cz-mix></div></div>'+
      '<div data-cz-tex-wrap><div class="mc-cz__lbl">Grinding Texture</div><div class="mc-cz__chips" data-cz-tex></div></div>'+
      '<div class="mc-cz__lbl">Quantity</div>'+
      '<div class="mc-cz__qty"><button class="mc-cz__qbtn" type="button" data-cz-dec>\u2212</button><span class="mc-cz__qn" data-cz-qn>1</span><button class="mc-cz__qbtn" type="button" data-cz-inc>+</button></div>'+
      '<div class="mc-cz__qmax">You can order maximum 10 packs at a time</div>'+
      '<div class="mc-cz__sum">'+
      '<div class="mc-cz__srow"><span data-cz-base-lbl>Base Price</span><span data-cz-base>-</span></div>'+
      '<div class="mc-cz__srow"><span>Customisation Charges</span><span data-cz-charge>+ \u20B90</span></div>'+
      '<div class="mc-cz__stot"><span>Total Price ( <span data-cz-packs>1</span> Pack<span data-cz-packs-s></span> )<small>(Inclusive of all taxes)</small></span><span data-cz-total>-</span></div>'+
      '</div>'+
      '<button class="mc-cz__go" type="button" data-cz-go>Proceed</button></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function(e){ if (e.target.closest('[data-cz-close]')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    el.querySelector('[data-cz-dec]').addEventListener('click', function(){ setQty(state.qty - 1); });
    el.querySelector('[data-cz-inc]').addEventListener('click', function(){ setQty(state.qty + 1); });
    el.querySelector('[data-cz-go]').addEventListener('click', proceed);
  }
  function close(){ if (el) el.classList.remove('is-open'); state = null; }
  function optIndex(product, rx){
    for (var i = 0; i < product.options.length; i++){
      var name = product.options[i].name || product.options[i];
      if (rx.test(name)) return i;
    }
    return -1;
  }

  // The variant for a given mix and texture at the chosen size, or null if
  // that combination does not exist on this product. Pure — it takes the
  // values it tests rather than swapping `state` and restoring it per chip.
  function find(mix, tex){
    var p = state.product;
    for (var i = 0; i < p.variants.length; i++){
      var v = p.variants[i];
      if (state.wi > -1 && v.options[state.wi] !== state.weight) continue;
      if (state.mi > -1 && v.options[state.mi] !== mix) continue;
      if (state.ti > -1 && v.options[state.ti] !== tex) continue;
      return v;
    }
    return null;
  }
  function variantFor(){ return find(state.mixture, state.texture); }
  function usable(v){ return !!(v && v.available); }

  function mixList(){
    return state.mi > -1 ? universe(MIX_ORDER, state.product.options[state.mi].values) : [];
  }
  function texList(){
    return state.ti > -1 ? universe(TEX_ORDER, state.product.options[state.ti].values) : [];
  }

  // A mix is selectable if ANY texture of it can be bought. Tested against
  // every texture rather than the current one, so picking a mix is never
  // blocked just because the texture already selected does not exist with
  // it — reconcile() moves the texture instead.
  function mixOk(m){
    if (state.ti < 0) return usable(find(m, null));
    return texList().some(function (t) { return usable(find(m, t)); });
  }
  // A texture is selectable only with the mix currently chosen.
  function texOk(t){ return usable(find(state.mixture, t)); }

  // After any change, pull the selection back onto something buyable. Left
  // alone, choosing a mix while an incompatible texture is selected would sit
  // on a combination that does not exist, with a dead Proceed button and no
  // reason given.
  function reconcile(){
    if (state.mi > -1 && !mixOk(state.mixture)){
      var m = mixList().filter(mixOk)[0];
      if (m) state.mixture = m;
    }
    if (state.ti > -1 && !texOk(state.texture)){
      var t = texList().filter(texOk)[0];
      if (t) state.texture = t;
    }
  }

  function baseVariant(){
    // Cheapest variant at the selected weight = the "no customisation" base
    // the mixture charge is measured against. Texture is priced the same
    // across all three, so it is not part of the baseline.
    var p = state.product, best = null;
    p.variants.forEach(function(v){
      if (state.wi > -1 && v.options[state.wi] !== state.weight) return;
      if (!best || v.price < best.price) best = v;
    });
    return best;
  }
  function chipHTML(name, sub){
    return '<b>' + name + '</b><small>' + sub + '</small>';
  }
  function chip(label, sub, onClass, ok, onPick){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mc-cz__chip' + onClass + (ok ? '' : ' is-off');
    // A real disabled attribute, not just a class: it cannot be clicked or
    // tabbed onto, and screen readers announce it as unavailable.
    if (!ok) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
    b.innerHTML = chipHTML(label, sub);
    if (ok) b.addEventListener('click', onPick);
    return b;
  }
  function renderChips(){
    var texWrap = el.querySelector('[data-cz-tex-wrap]'), tex = el.querySelector('[data-cz-tex]');
    var mixWrap = el.querySelector('[data-cz-mix-wrap]'), mix = el.querySelector('[data-cz-mix]');
    tex.innerHTML = ''; mix.innerHTML = '';
    mixWrap.style.display = state.mi > -1 ? '' : 'none';
    texWrap.style.display = state.ti > -1 ? '' : 'none';

    if (state.mi > -1){
      var bv = baseVariant();
      mixList().forEach(function(val){
        var ok = mixOk(val);
        // Priced from whichever texture of this mix exists — they are all
        // priced alike. Disabled chips say so rather than quoting a charge
        // for something that cannot be bought.
        var priced = find(val, state.texture) ||
          texList().map(function (t) { return find(val, t); }).filter(Boolean)[0] || null;
        var charge = (priced && bv) ? priced.price - bv.price : 0;
        var sub = !ok ? 'Unavailable' : (charge > 0 ? '+ ' + fmt(charge) : '\u20B90');
        mix.appendChild(chip(val, sub, val === state.mixture ? ' is-on is-on--green' : '', ok,
          function(){ state.mixture = val; update(); }));
      });
    }

    if (state.ti > -1){
      texList().forEach(function(val){
        var ok = texOk(val);
        // All three textures cost the same; the label says so rather than
        // showing a redundant zero.
        tex.appendChild(chip(val, ok ? 'Free' : 'Unavailable', val === state.texture ? ' is-on' : '', ok,
          function(){ state.texture = val; update(); }));
      });
    }
  }
  function setQty(q){
    state.qty = Math.min(10, Math.max(1, q));
    update();
  }
  function update(){
    reconcile();
    renderChips();
    var v = variantFor(), bv = baseVariant();
    var base = bv ? bv.price : (v ? v.price : 0);
    var charge = v && bv ? v.price - bv.price : 0;
    el.querySelector('[data-cz-qn]').textContent = state.qty;
    el.querySelector('[data-cz-base-lbl]').textContent = 'Base Price' + (state.weight ? ' (' + state.weight + ')' : '');
    el.querySelector('[data-cz-base]').textContent = fmt(base);
    el.querySelector('[data-cz-charge]').textContent = '+ ' + fmt(charge);
    el.querySelector('[data-cz-packs]').textContent = state.qty;
    el.querySelector('[data-cz-packs-s]').textContent = state.qty > 1 ? 's' : '';
    el.querySelector('[data-cz-total]').textContent = v ? fmt(v.price * state.qty) : '-';
    var banner = el.querySelector('[data-cz-banner]');
    if (charge > 0){
      banner.classList.add('is-on');
      el.querySelector('[data-cz-banner-name]').textContent = state.mixture;
      el.querySelector('[data-cz-banner-charge]').textContent = '+' + fmt(charge);
    } else {
      banner.classList.remove('is-on');
    }
    // If nothing at this size can be bought, every chip is disabled and
    // Proceed stays off. The popup still opens so the customer sees the
    // range, rather than a button that silently does nothing.
    el.querySelector('[data-cz-go]').disabled = !usable(v);
  }
  function proceed(){
    var v = variantFor();
    if (!usable(v)) return;
    var go = el.querySelector('[data-cz-go]');
    go.disabled = true;
    // No line-item property: texture is a variant now, so the chosen SKU
    // already carries it. Sending both would record the same choice twice
    // and let them disagree on the order.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: state.qty })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) {
            // Shopify puts the real reason in `description` — "sold out",
            // "only N available". Showing it beats a generic retry message.
            var e = new Error(d.description || d.message || 'add failed');
            e.status = r.status;
            throw e;
          }
          return d;
        });
      })
      .then(function () {
        // Read what we need BEFORE close(), which sets `state` to null.
        var mode = state.mode;
        close();
        // The add has already succeeded. Nothing below may report itself as
        // an add failure — that was the bug: a throw in MCCheckout.open()
        // surfaced as "could not add to cart" while the item sat in the cart.
        try {
          if (mode === 'buy') {
            // Buy Now goes through the address picker, not straight to
            // Shopify. A bare location.href fires no click, so mc-checkout's
            // interceptor never sees it — hence calling the API directly.
            if (window.MCCheckout && typeof window.MCCheckout.open === 'function') {
              window.MCCheckout.open();
            } else {
              window.location.href = '/checkout';   // picker absent: never block the sale
            }
            return;
          }
          if (window.MCCart && typeof window.MCCart.open === 'function') {
            window.MCCart.open();
          } else {
            document.dispatchEvent(new CustomEvent('mc:cart:added'));
            setTimeout(function () {
              if (!document.querySelector('[data-mc-cart-drawer]')) window.location.href = '/cart';
            }, 60);
          }
        } catch (err) {
          // Navigation broke but the cart is correct — fall through rather
          // than stranding the customer on a dead popup.
          console.error('post-add navigation failed', err);
          window.location.href = mode === 'buy' ? '/checkout' : '/cart';
        }
      })
      .catch(function (err) {
        go.disabled = false;
        console.error('cart/add failed', err);
        alert(err && err.message ? err.message : 'Could not add to cart. Please try again.');
      });
  }

  window.MCCustomise = {
    hasCustom: function(product){
      return optIndex(product, MIXTURE_RX) > -1 || optIndex(product, TEXTURE_RX) > -1;
    },
    open: function(opts){
      if (!el) build();
      fetch('/products/' + opts.handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(p){
          var ti = optIndex(p, TEXTURE_RX);
          var wi = optIndex(p, WEIGHT_RX), mi = optIndex(p, MIXTURE_RX);
          state = {
            product: p, mode: opts.mode === 'buy' ? 'buy' : 'add',
            wi: wi, mi: mi, ti: ti,
            weight: opts.weight || (wi > -1 ? p.options[wi].values[0] : null),
            texture: null,
            mixture: null,
            qty: 1
          };
          // Open on the first option in OUR order — No Mix, Baareek — and let
          // reconcile() in update() step past anything unbuyable, so the popup
          // never opens with a disabled chip selected.
          if (mi > -1) state.mixture = mixList()[0];
          if (ti > -1) state.texture = texList()[0];
          el.querySelector('[data-cz-note]').textContent = window.MC_CUSTOM_NOTE ||
            'Customise your atta the way your kitchen likes it. Charges for mixtures are added per pack.';
          el.classList.add('is-open');
          update();
        });
    }
  };
  // global delegate: any element with data-mc-customise opens the popup
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-mc-customise]');
    if (!t) return;
    e.preventDefault();
    var weightSel = t.getAttribute('data-weight-from');
    var weight = t.getAttribute('data-weight') || null;
    if (weightSel){
      var src = document.querySelector(weightSel);
      if (src) weight = src.value || src.getAttribute('data-weight') || weight;
    }
    window.MCCustomise.open({
      handle: t.getAttribute('data-handle'),
      weight: weight,
      mode: t.getAttribute('data-mode') || 'add'
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-city-gate"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var root = document.querySelector('[data-mc-city-gate]');
  if (!root || window.MCCityGate) return;

  var PIN_KEY = 'mc:pin';   // shared with mc-pincode

  var STATE_FOR = { 'Bengaluru': 'Karnataka', 'Delhi + NCR': 'Delhi' };

  function stored() {
    try { return JSON.parse(localStorage.getItem(PIN_KEY)); }
    catch (e) { return null; }
  }

  function open() {
    root.hidden = false;
    document.body.classList.add('mc-cg-locked');
  }
  function close() {
    root.hidden = true;
    document.body.classList.remove('mc-cg-locked');
  }

  function choose(city) {
    /* A city is a browsing preference, not a delivery address. `source` says
       so explicitly: the pincode picker still has to run before checkout, and
       nothing downstream should read this as a verified serviceable pin. */
    var record = {
      pin: null,
      area: null,
      city: city,
      state: STATE_FOR[city] || null,
      source: 'city'
    };
    try { localStorage.setItem(PIN_KEY, JSON.stringify(record)); } catch (e) {}

    close();

    // Same event mc-pincode fires, so mc-region re-filters and re-routes and
    // the header pill repaints without a reload.
    document.dispatchEvent(new CustomEvent('mc:pin', { detail: record }));
  }

  root.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-mc-cg-pick]');
    if (pick) return choose(pick.getAttribute('data-mc-cg-pick'));
    if (e.target.closest('[data-mc-cg-close]')) return close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  window.MCCityGate = { open: open, close: close };

  /* Open unless a city or pincode is already set. A real pincode always wins —
     someone who typed one has told us more than a city ever could. */
  function maybeOpen() {
    var s = stored();
    if (s && (s.pin || s.city)) return;
    open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeOpen);
  } else {
    maybeOpen();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-product-card"] && !Shopify.designMode) return;
  try {
    /* One cart read shared by every card on the page. Previously each card only
   fetched the cart when MCCart was absent — and the cart drawer defines
   MCCart, so on a normal page nothing fetched at all and the steppers stayed
   hidden until some other code happened to broadcast mc:cart:updated. That
   is why a reload never showed items already in the cart.
   One request serves every card; a page with twenty cards no longer makes
   twenty. */
(function(){
  if (window.MCCardCart) return;
  var listeners = [], last = null, inflight = null;
  function set(cart){
    if (!cart || !cart.items) return;
    last = cart;
    listeners.forEach(function(fn){ try { fn(cart); } catch (e) { console.warn('[mc-card]', e); } });
  }
  function load(){
    if (inflight) return inflight;
    inflight = fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ inflight = null; set(c); return c; })
      .catch(function(){ inflight = null; return last; });
    return inflight;
  }
  // Any code that changes the cart announces it one of these two ways. The
  // popup in mc-base only sends mc:cart:added, and only when the drawer is
  // missing, so both are listened for rather than trusting one.
  document.addEventListener('mc:cart:updated', function(e){
    if (e.detail && e.detail.cart) set(e.detail.cart); else load();
  });
  document.addEventListener('mc:cart:added', function(){ load(); });
  // Back-navigation restores the page from bfcache with its old cart state.
  window.addEventListener('pageshow', function(e){ if (e.persisted) load(); });
  window.MCCardCart = {
    on: function(fn){ listeners.push(fn); if (last) fn(last); },
    load: load
  };
  load();
})();

document.querySelectorAll('[data-mc-product-card]').forEach(function(card){
  if (card.dataset.mcBound) return;
  card.dataset.mcBound = '1';
  var sel = card.querySelector('[data-mc-wsel], [data-mc-vsel]');
  // Two kinds of select. Lokwan and Sharbati hold the SIZE ("1kg") and let
  // the popup choose mix and texture; every other card holds the VARIANT ID.
  var holdsVariantId = !!(sel && sel.hasAttribute('data-mc-vsel'));
  var handle = card.getAttribute('data-handle');
  var addWrap = card.querySelector('[data-mc-addwrap]');
  var stepWrap = card.querySelector('[data-mc-step]');
  var qEl = card.querySelector('[data-mc-stepn]');
  var lastCart = null;

  function linesFor(cart){
    if (!cart || !cart.items || !sel) return [];
    var val = sel.value;
    return cart.items.filter(function(it){
      if (it.handle !== handle) return false;
      // A variant-ID select matches on the ID. The old code compared the
      // item's Size value ("1kg") against the ID here, which can never be
      // equal — so plain cards never showed a stepper at all.
      if (holdsVariantId) return String(it.variant_id) === String(val);
      var opts = it.options_with_values || [];
      var wo = opts.filter(function(o){ return /size|weight/i.test(o.name); })[0];
      return wo ? wo.value === val : true;
    });
  }
  function paint(cart){
    if (cart) lastCart = cart;
    if (!stepWrap || !addWrap) return;
    var qty = linesFor(lastCart).reduce(function(n, it){ return n + it.quantity; }, 0);
    stepWrap.hidden = qty === 0;
    addWrap.hidden = qty > 0;
    if (qEl && qty > 0) qEl.textContent = qty;
  }
  function announce(cart){
    // Broadcast rather than paint locally, so the drawer, the mobile nav
    // badge and every other card showing this product all update together.
    document.dispatchEvent(new CustomEvent('mc:cart:updated', { detail: { cart: cart } }));
  }
  function bump(delta){
    var lines = linesFor(lastCart);
    if (!lines.length) return;
    // A size can have several lines — 1kg Baareek and 1kg Medium Millet. The
    // stepper adjusts the most recently added one; the drawer lists each.
    var line = lines[lines.length - 1];
    var next = Math.max(0, line.quantity + delta);
    if (window.MCCart && window.MCCart.change){
      window.MCCart.change(line.key, next);
      return;
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: next })
    }).then(function(r){ return r.json(); }).then(announce).catch(function(){});
  }
  function syncBtn(opt){
    var btn = card.querySelector('[data-mc-cz], .mc-pc__cart');
    if (!btn || !opt || opt.dataset.available === undefined) return;
    var ok = opt.dataset.available === 'true';
    btn.disabled = !ok;
    btn.textContent = ok ? 'Add to Cart' : 'Sold Out';
  }
  if (sel){
    sel.addEventListener('change', function(){
      var opt = sel.options[sel.selectedIndex];
      var now = card.querySelector('[data-mc-now]');
      var cmp = card.querySelector('[data-mc-compare]');
      if (now && opt.dataset.price) now.textContent = opt.dataset.price;
      if (cmp){
        if (opt.dataset.compare){ cmp.textContent = opt.dataset.compare; cmp.style.display = ''; }
        else { cmp.style.display = 'none'; }
      }
      // Availability is per SIZE, not per product: 2kg can be sold out while
      // 5kg is in stock.
      syncBtn(opt);
      paint();
    });
  }

  // Customisable cards: the popup adds, then announces via mc:cart:added.
  var cz = card.querySelector('[data-mc-cz]');
  if (cz){
    cz.addEventListener('click', function(){
      if (!window.MCCustomise) return;
      var wsel = card.querySelector('[data-mc-wsel]');
      window.MCCustomise.open({
        handle: handle,
        weight: wsel ? wsel.value : null,
        mode: cz.getAttribute('data-mode') || 'add'
      });
    });
  }

  // Plain cards: add in place instead of submitting the form. A real submit
  // navigates to /cart, so the card never gets the chance to turn into a
  // stepper — the page it would update has already gone.
    // Plain cards add with a button click, not a form submit. Inside a real
  // product form, another script on the page also caught the submit and
  // added a second unit.
  var form = card.querySelector('.mc-pc__form');
  var addBtn = form && form.querySelector('[data-mc-add]');
  if (addBtn){
    addBtn.addEventListener('click', function(e){
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]');
      var btn = addBtn;
      if (!idEl || btn.disabled) return;
      if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idEl.value, quantity: 1 })
      })
        .then(function(r){
          return r.json().catch(function(){ return {}; }).then(function(d){
            if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
            return d;
          });
        })
        .then(function(){ return window.MCCardCart.load(); })
        .then(function(cart){
          announce(cart);
          if (window.MCCart && typeof window.MCCart.open === 'function') window.MCCart.open();
        })
        .catch(function(err){ alert(err && err.message ? err.message : 'Could not add to cart.'); })
        .then(function(){
          if (btn) btn.disabled = false;
          if (sel) syncBtn(sel.options[sel.selectedIndex]);
          else if (btn) btn.textContent = 'Add to Cart';
        });
    });
  }

  if (stepWrap){
    stepWrap.querySelector('[data-mc-dec]').addEventListener('click', function(){ bump(-1); });
    stepWrap.querySelector('[data-mc-inc]').addEventListener('click', function(){ bump(1); });
  }
  if (sel) syncBtn(sel.options[sel.selectedIndex]);
  window.MCCardCart.on(paint);
});
  } catch(e) { console.error(e); }
})();

})();
